// One ad-pixel conversion per takeover session per browser.
//
// Step22Confirmation fires CompleteRegistration when the completion gate
// opens. A ref guarded it, but a ref dies with the page: a seller who reloads
// /completed resumes the same completed session (takeover.sessionId +
// takeover.step persist in localStorage), the gate opens again, and Meta
// counts a second CompleteRegistration for one sign-up. Found by the verifier
// on meta-pixel-landing-sites (2026-10-07): 1 after the first load, 2 after a
// reload.
//
// So the "already fired" fact lives in localStorage, keyed by event and
// session id. When storage throws (private mode, blocked site data) we fall
// back to a module-level set, which still holds for the life of the page --
// the old behaviour, never worse.

const memory = new Set();

function storageKey(eventName, sessionId) {
  return `takeover.conversionFired.${eventName}.${sessionId}`;
}

// True exactly once per (eventName, sessionId) in this browser; the caller
// fires the pixel only on true. No session id means no conversion: a page
// reached outside a real takeover flow is not a completed sign-up.
export function claimConversion(eventName, sessionId) {
  if (!eventName || !sessionId) return false;
  const key = storageKey(eventName, sessionId);
  if (memory.has(key)) return false;
  memory.add(key);
  try {
    if (window.localStorage.getItem(key)) return false;
    window.localStorage.setItem(key, new Date().toISOString());
  } catch {
    // Storage unavailable: the in-memory claim above still stands.
  }
  return true;
}

// Test hook: forget the in-memory claims (a real reload does this).
export function _resetConversionMemoryForTests() {
  memory.clear();
}
